import { gql, useQuery } from "@apollo/client";
import { useEffect } from "react";
import Loader from "../genericComponents/Loader";
import GenericViewInputs from "../genericComponents/GenericViewInputs";
import { Info } from "@mui/icons-material";
const UsageDetails = (props) => {
  useEffect(() => {
    props.setHeader({icon:Info,text:"i18n_usagedetails_header"})
  }, [props.setHeader])

  const USAGE_QUERY = `query GET_USAGE_DETAILS($id:UUID!,$end:DateTime!,$level:Level!,$meterType:MeterType!,$start:DateTime!)
{
  usageDetails(chartInput:{id:$id,end: $end,level: $level,meterType: $meterType, start: $start }){
    isSuccess
    message
    value
    {
      max{
        month
        year
        hour
        day
        fifteenMinutes
      }
      min{
        month
        year
        hour
        day
        fifteenMinutes
      }
      averages{
        day
        month
        year
      }
      dataQuality{
        amountOfDays
        dataPoints
        missingDataPoints
      }
    }  
  }
}
      `
  const { data, loading } = useQuery(gql(USAGE_QUERY),
    {
      variables: {
        id: props.data.id,
        end: props.data.end,
        start: props.data.start,
        level: props.data.level,
        meterType: props.data.meterType
      }
    });
  if (loading||!data) {
    return <Loader text="Loading data..." />
  }

  const viewObject = data.usageDetails.value;
  return <GenericViewInputs viewObject={viewObject} baseKey="usageDetails" />
}
export default UsageDetails;